import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";

const CartsPage = lazy(() => import("./pages/CartsPage").then((module) => ({ default: module.CartsPage })));

const CartEditorPage = lazy(() => import("./pages/CartEditorPage").then((module) => ({ default: module.CartEditorPage })));

export const cartsRoutes: RouteObject[] = [
  { path: "carts/new", element: <RouteSuspense><CartEditorPage /></RouteSuspense> },
  { path: "carts/:cartId", element: <RouteSuspense><CartEditorPage /></RouteSuspense> },
  { path: "carts", element: <RouteSuspense><CartsPage /></RouteSuspense> },
];
